import { useEffect, useState } from "react";
import { apiFetch } from "api/Api";
import { useParams, useNavigate, Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import "assets/theme/admin_form.css";

const EditLetterTemplate = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [templateTitle, setTemplateTitle] = useState("");
  const [templateContent, setTemplateContent] = useState("");
  const [templateFields, setTemplateFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, [id]);

  const loadData = async () => {
    try {
      const templateRes = await apiFetch(`super_admin/get_letter_format_by_id/${id}`);
      const template = templateRes.letter_format;

      setCategoryId(template.category_id);
      setTemplateTitle(template.template_title);
      setTemplateContent(template.template_content);
      setTemplateFields(templateRes.template_fields || []);

      const categoryRes = await apiFetch("super_admin/list_help_category");
      setCategories(categoryRes.categories || []);
    } catch (error) {
      alert(error.message);
    } finally {
      setPageLoading(false);
    }
  };

  const generateKey = (label) => {
    return label
      .toLowerCase()
      .replace(/\s+/g, "_")
      .replace(/[^a-z0-9_]/g, "");
  };

  const addField = () => {
    setTemplateFields([
      ...templateFields,
      {
        field_label: "",
        field_key: "",
        field_type: "text",
        is_required: false,
      },
    ]);
  };

  const removeField = (index) => {
    const updated = [...templateFields];
    updated.splice(index, 1);
    setTemplateFields(updated);
  };

  const handleFieldChange = (index, key, value) => {
    const updated = [...templateFields];

    if (key === "field_label") {
      updated[index].field_label = value;
      updated[index].field_key = generateKey(value);
    } else {
      updated[index][key] = value;
    }

    setTemplateFields(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!categoryId || !templateTitle.trim() || !templateContent.trim()) {
      return alert("सर्व आवश्यक माहिती भरा");
    }

    setLoading(true);

    try {
      await apiFetch(`super_admin/edit_letter_format/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          category_id: categoryId,
          template_title: templateTitle.trim(),
          template_content: templateContent.trim(),
          template_fields: templateFields,
        }),
      });

      alert("पत्र नमुना यशस्वीरित्या अपडेट झाला");
      navigate("/letter_template_list");
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid mt-4" style={{ fontSize: "0.9rem" }}>
        {/* Header Card */}
        <div className="admin-form-header-card">
          <div className="d-flex align-items-center gap-3">
            <button type="button" onClick={() => navigate(-1)} className="btn-admin-back">
              <FaArrowLeft />
              <span>मागे जा (Back)</span>
            </button>
            <div>
              <h4 className="fw-bold mb-1 text-white">
                ✏️ पत्र नमुना संपादित करा (Edit Letter Template)
              </h4>
              <small className="text-white-50">
                शीर्षक, मजकूर आणि अतिरिक्त फील्ड अपडेट करा
              </small>
            </div>
          </div>

          <Link to="/letter_template_list" className="btn btn-light btn-sm fw-semibold rounded-pill px-3">
            Template List
          </Link>
        </div>

        {pageLoading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" />
          </div>
        ) : (
          <div className="card shadow-lg rounded-4 border-0">
            <div className="card-body p-4">
              <form onSubmit={handleSubmit}>
                <div className="row g-4">
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">श्रेणी निवडा</label>
                    <select
                      className="form-select"
                      value={categoryId}
                      onChange={(e) => setCategoryId(e.target.value)}
                      required
                    >
                      <option value="">श्रेणी निवडा</option>
                      {categories.map((cat) => (
                        <option key={cat.category_id} value={cat.category_id}>
                          {cat.category_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-semibold">पत्र शीर्षक</label>
                    <input
                      type="text"
                      className="form-control"
                      value={templateTitle}
                      onChange={(e) => setTemplateTitle(e.target.value)}
                      required
                    />
                  </div>

                  <div className="col-12">
                    <label className="form-label fw-semibold">पत्र मजकूर</label>
                    <textarea
                      rows="6"
                      className="form-control"
                      value={templateContent}
                      onChange={(e) => setTemplateContent(e.target.value)}
                      required
                    ></textarea>
                  </div>

                  <div className="col-12">
                    <div className="card border-0 bg-light">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h6 className="fw-bold mb-0" style={{ fontSize: "0.95rem" }}>अतिरिक्त फील्ड</h6>
                          <button type="button" className="btn btn-sm btn-success" style={{ fontSize: "0.8rem" }} onClick={addField}>
                            + फील्ड जोडा
                          </button>
                        </div>

                        {templateFields.length === 0 ? (
                          <div className="text-muted">अतिरिक्त फील्ड जोडलेले नाहीत.</div>
                        ) : (
                          templateFields.map((field, index) => (
                            <div key={index} className="border rounded p-3 mb-3 bg-white">
                              <div className="row g-3">
                                <div className="col-md-4">
                                  <label className="form-label">फील्ड नाव</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={field.field_label}
                                    onChange={(e) =>
                                      handleFieldChange(index, "field_label", e.target.value)
                                    }
                                  />
                                </div>

                                <div className="col-md-3">
                                  <label className="form-label">फील्ड की</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={field.field_key}
                                    readOnly
                                  />
                                </div>

                                <div className="col-md-3">
                                  <label className="form-label">प्रकार</label>
                                  <select
                                    className="form-select"
                                    value={field.field_type}
                                    onChange={(e) =>
                                      handleFieldChange(index, "field_type", e.target.value)
                                    }
                                  >
                                    <option value="text">Text</option>
                                    <option value="number">Number</option>
                                    <option value="date">Date</option>
                                    <option value="textarea">Textarea</option>
                                  </select>
                                </div>

                                <div className="col-md-2">
                                  <label className="form-label">आवश्यक</label>
                                  <div className="form-check form-switch mt-2">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      checked={field.is_required}
                                      onChange={(e) =>
                                        handleFieldChange(index, "is_required", e.target.checked)
                                      }
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="mt-3 text-end">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-danger"
                                  onClick={() => removeField(index)}
                                >
                                  काढून टाका
                                </button>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-4 text-end">
                  <button type="submit" className="btn btn-primary px-5" disabled={loading} style={{ fontSize: "0.85rem" }}>
                    {loading ? "अपडेट होत आहे..." : "नमुना अपडेट करा"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default EditLetterTemplate;
